module.exports = __webpack_public_path__ + "static/media/dongzhe.54430a23.png";